import gql from "graphql-tag";

const GET_USER_DETAILS = gql`
    query MyQuery {
        spendmd_db_users(order_by: { role: { name: asc } }) {
            name
            id
            account_disabled
            client_id
            email
            image
            is_rejected
            role {
                name
            }
            client {
                name
            }
            verification_pending
        }
    }
`;

const INSERT_USER = gql`
    mutation MyMutation(
        $client_id: uuid!
        $email: String!
        $name: String!
        $added: timestamp!
        $updated: timestamp!
    ) {
        insert_spendmd_db_users(
            objects: {
                client_id: $client_id
                email: $email
                name: $name
                added: $added
                updated: $updated
                role_id: "38efdcab-79cc-4876-b0ef-e5f569a13bce" # client_user role
            }
        ) {
            returning {
                name
                id
                account_disabled
                client_id
                email
                image
                is_rejected
                role {
                    name
                }
                client {
                    name
                }
                verification_pending
            }
        }
    }
`;

const UPDATE_USER = gql`
    mutation(
        $id: uuid!
        $name: String
        $account_disabled: Boolean!
        $updated: timestamp!
    ) {
        update_spendmd_db_users(
            where: { id: { _eq: $id } }
            _set: {
                name: $name
                account_disabled: $account_disabled
                updated: $updated
            }
        ) {
            returning {
                id
            }
        }
    }
`;

const CHANGE_USER_STATUS = gql`
    mutation($id: uuid!, $account_disabled: Boolean!, $updated: timestamp!) {
        update_spendmd_db_users(
            where: { id: { _eq: $id } }
            _set: { account_disabled: $account_disabled, updated: $updated }
        ) {
            returning {
                id
            }
        }
    }
`;

const DELETE_USER = gql`
    mutation($id: uuid!) {
        delete_spendmd_db_users(where: { id: { _eq: $id } }) {
            returning {
                id
            }
        }
    }
`;

export default {
    GET_USER_DETAILS,
    INSERT_USER,
    UPDATE_USER,
    CHANGE_USER_STATUS,
    DELETE_USER
};
